import { useLocalization } from "@tm/localization"
import { Box, Button, Icon, IconButton, ModuleHeaderContainer, ModuleHeaderSlot, SearchField, Switch } from "@tm/components"
import { useCallback, useState } from "react"
import { useCustomArticlesDefaults } from "@tm/data/basket"
import { Navigation } from "../Navigation"
import { useListSettings } from "./useListSettings"
import { useOwnArticlesStore } from "./store"

type ModuleHeaderProps = {
    onClose?: () => void
}

export function ModuleHeader({ onClose }: ModuleHeaderProps) {
    const { translateText } = useLocalization()
    const { isLoading, showPurchasePrice, handleChangeShowPurchasePrice } = useListSettings()
    const { customArticlesDefaults } = useCustomArticlesDefaults()
    const { searchQuery, setSearchQuery, setArticleToEdit } = useOwnArticlesStore()

    const [query, setQuery] = useState(searchQuery)

    function handleStartSearch() {
        setSearchQuery(query)
    }

    function handleClearSearch() {
        setSearchQuery("")
    }

    const handleNewArticle = useCallback(() => {
        const selectedVatRate = customArticlesDefaults?.defaultVatRates?.find((vatRate) => vatRate.isSelected)
        const categoryId = customArticlesDefaults?.categories.first()?.categoryId
        if (selectedVatRate && categoryId) {
            setArticleToEdit({ type: "add", description: "", selectedVatRate, categoryId })
        }
    }, [customArticlesDefaults?.categories, customArticlesDefaults?.defaultVatRates, setArticleToEdit])

    return (
        <ModuleHeaderContainer>
            <Navigation listType="own-articles" />
            <ModuleHeaderSlot title={translateText(135)}>
                <SearchField
                    sx={{ width: "300px" }}
                    onStartSearch={handleStartSearch}
                    value={query}
                    onChange={setQuery}
                    onClear={handleClearSearch}
                    placeholder={`${translateText(87)} ${translateText(1098)} ${translateText(25)}`}
                />
            </ModuleHeaderSlot>
            <ModuleHeaderSlot title={translateText(177)}>
                <Button startIcon={<Icon name="plus" />} onClick={handleNewArticle} variant="outlined">
                    {translateText(13906)}
                </Button>
            </ModuleHeaderSlot>
            <ModuleHeaderSlot title={translateText(1132)} hideDivider>
                {/* Purchase Price */}
                <Switch checked={showPurchasePrice} onChange={handleChangeShowPurchasePrice} disabled={isLoading} />
            </ModuleHeaderSlot>

            {onClose && (
                <Box ml="auto" alignSelf="start" mt={2}>
                    <IconButton variant="contained" onClick={onClose} color="primary" size="large">
                        <Icon name="close" />
                    </IconButton>
                </Box>
            )}
        </ModuleHeaderContainer>
    )
}
